export const translations = {
    booking: {
        time_left: {
            en: 'Time left to send the request',
            hr: 'Vrijeme preostalo za slanje upita',
        },
        info: {
            en: 'Most booking requests are successfully confirmed. If any problems during the booking process occur, contact us at {phone} or email {email}.',
            hr: 'Većina zahtjeva za rezervaciju uspješno je potvrđena. Ukoliko imate problema s kupovinom slobodno nas kontaktirajte na {phone} ili email {email}.',
        },
        payment_error: {
            en: 'If you experience any payment issues, please call us at {phone} or email us at {email}.',
            hr: 'Ako imate problema s plaćanjem, nazovite nas na {phone} ili nam pošaljite email na {email}.',
        },
        success: {
            congratulations_title: {
                en: 'Congratulations!',
                hr: 'Čestitamo!',
            },
            congratulations_text: {
                en:
                    'Your request has been sent and the host will confirm it as soon as possible. Please make sure to notify your host or Authland if you change your plan regarding the arrival in any way.',
                hr:
                    'Vaš je zahtjev poslan, a domaćin će ga potvrditi u najkraćem mogućem roku. Obavezno obavijestite domaćina ili Authland ako na bilo koji način promijenite plan u vezi s dolaskom.',
            },
            transportation: {
                en:
                    'If you need a quality transportation to the location, book it <a href="https://book.atobtransfer.com/book?atob_ref=AUTHLAND" target="_blank">here</a>, or contact us at <a class="nowrap" href="tel:+385919823880">+385 91 982 3880</a> or <a class="nowrap" href="mailto:experiences@authland.com">experiences@authland.com</a>.',
                hr:
                    'Ako trebate kvalitetan prijevoz do lokacije, rezervirajte ga <a href="https://book.atobtransfer.com/book?atob_ref=AUTHLAND" target="_blank">ovdje</a>, ili nas kontaktirajte na <a class="nowrap" href="tel:+385919823880">+385 91 982 3880</a> ili <a class="nowrap" href="mailto:experiences@authland.com">experiences@authland.com</a>.',
            },
            enjoy: {
                en: 'Enjoy your authentic experience!',
                hr: 'Uživajte u svom autentičnom iskustvu!',
            },
            cta_text: {
                en: 'Book a transfer',
                hr: 'Rezervirajte prijevoz',
            },
        },
        errors: {
            something_went_wrong: {
                en:
                    '<span>Something went wrong, please refresh the page and try again. If the problem persists do not hesitate to contact us at <a class="nowrap" href="tel:+385919823880">+385 91 982 3880</a> or email <a href="mailto:support@authland.com">support@authland.com</a>.</span>',
                hr:
                    '<span>Došlo je do greške. Molimo Vas pokušajte kasnije ili nas kontaktirajte na <a class="nowrap" href="tel:+385919823880">+385 91 982 3880</a> ili email <a href="mailto:support@authland.com">support@authland.com</a>.</span>',
            },
            session_expired: {
                en: 'Sorry, your session has expired. Please refresh the page and try again.',
                hr: 'Vaša sesija je istekla, molimo Vas da učitate stranicu i pokušate ponovno.',
            },
        },
    },
    customerInfoAndPayment: {
        title: {
            en: 'Enter personal info & book',
            hr: 'Osobni podaci i rezerviranje',
        },
        total_people: {
            en: 'Selected number of people',
            hr: 'Odabrani broj osoba',
        },
        price: {
            en: 'Price',
            hr: 'Cijena usluga',
        },
        subtotal: {
            en: 'Price with discount',
            hr: 'Cijena s popustom',
        },
        total: {
            en: 'Total price',
            hr: 'Ukupna cijena',
        },
        see_details: {
            en: 'Show details',
            hr: 'Prikaži detalje',
        },
        hide_details: {
            en: 'Hide details',
            hr: 'Sakrij detalje',
        },
        edit: {
            en: 'Edit',
            hr: 'Izmjenite',
        },
        back: {
            en: 'Go Back',
            hr: 'Prethodni korak',
        },
        steps: {
            personal: {
                en: '1. Personal info',
                hr: '1. Osobni podaci',
            },
            payment: {
                en: '2. Payment',
                hr: '2. Plaćanje',
            },
        },
        form: {
            next: {
                en: 'Next',
                hr: 'Dalje',
            },
            fullname: {
                en: 'First and last name',
                hr: 'Ime i prezime',
            },
            country: {
                en: 'Country',
                hr: 'Država',
            },
            country_select: {
                en: 'Please choose your country',
                hr: 'Molimo odaberite državu',
            },
            country_code: {
                en: 'Country code',
                hr: 'Pozivni br.',
            },
            email: {
                en: 'Email address (voucher delivery)',
                hr: 'Email adresa (dostava vouchera)',
            },
            phone: {
                en: 'Phone number',
                hr: 'Kontakt broj mobitela',
            },
            message: {
                en: 'Message (optional)',
                hr: 'Poruka (opcionalno)',
            },
            message_placeholder: {
                en:
                    'Communicate any additional details about your group if service provider should know those. If the service was bought at a group price, emphasize how many people are coming exactly.',
                hr:
                    'Komunicirajte ponuđaču usluge ako bi trebao znati dodatne detalje o Vašoj grupi. Ukoliko ste kupili uslugu po grupnoj cijeni, naglasite koliko vas točno dolazi.',
            },
            notification: {
                en: 'I want to receive a confirmation SMS.',
                hr: 'Želim primiti SMS s potvrdom rezervacije.',
            },
            newsletter: {
                en:
                    'I want to occassionaly receive notifications on new services, products and promotional activities.',
                hr:
                    'Želim povremeno primati email obavijesti o novim uslugama, proizvodima i promotivnim aktivnostima.',
            },
        },
        payment: {
            direct_payment_info: {
                en:
                    'You will book now, after your host confirms the request & pay directly to her/him once you arrive at the location.',
                hr:
                    'Rezervirat ćete sada, kada domaćin potvrdi zahtjev, a platiti izravno njoj/njemu jednom kada stignete na lokaciju.',
            },
            total_in_hrk: {
                en: 'Total price:',
                hr: 'Ukupna cijena:',
            },
            purchase_info: {
                en:
                    'The amount of your purchase will be reserved. It will be fully charged only after the confirmation by the service provider.',
                hr:
                    'Iznos Vaše kupovine će se rezervirati. Biti će naplaćen u potpunosti tek nakon potvrde od strane ponuđača usluge.',
            },
            currency_info: {
                en: 'The payment is made in Euro (EUR).',
                hr: 'Plaćanje se vrši u eurima (EUR).',
            },
            buttons: {
                pay_now: {
                    en: 'PAY NOW',
                    hr: 'PLATI SAD',
                },
                confirm: {
                    en: 'Confirm',
                    hr: 'Potvrdite',
                },
            },
            safe_payment: {
                en: 'Your payment is safe',
                hr: 'Vaša uplata je sigurna',
            },
        },
        buttons: {
            qrcode: {
                en: 'Share cart with another person via QR code',
                hr: 'Podijeli košaricu s drugom osobom preko QR koda',
            },
        },
        errors: {
            required: {
                en: 'This field is required',
                hr: 'Ovo polje je obavezno',
            },
            email: {
                en: 'Value is not a valid email address',
                hr: 'Unesena vrijednost nije ispravna email adresa',
            },
            contact_number: {
                en: 'Area code and contact number are required',
                hr: 'Pozivni i kontakt broj su obavezni',
            },
        },
        links: {
            privacy_policy: {
                en: 'Privacy Policy',
                hr: 'Politika Privatnosti',
            },
            terms_and_conditions: {
                en: 'Terms and conditions',
                hr: 'Opći uvjeti poslovanja',
            },
        },
        smsDisclaimer: {
            en:
                'The phone number is required for SMS notifications. You will receive an SMS regardless of whether the reservation is rejected or accepted.',
            hr:
                'Telefonski broj je obavezan zbog SMS notifikacija. Primit ćete SMS bez obzira da li je rezervacija odbijena ili prihvaćena.',
        },
    },
    offers: {
        section_title: {
            en: 'Select your offer and no. of people',
            hr: 'Odaberite ponudu i br. osoba',
        },
        offer: {
            en: 'Prices',
            hr: 'Cijene',
        },
        persons: {
            en: (num) => `${num} people`,
            hr: (num) => `${num} osoba`,
        },
        show_details: {
            en: 'Show details',
            hr: 'Prikaži detalje',
        },
        hide_details: {
            en: 'Hide details',
            hr: 'Sakrij detalje',
        },
        duration: {
            en: 'Duration',
            hr: 'Trajanje',
        },
        difficulty: {
            en: 'Difficulty',
            hr: 'Težina',
        },
        amount: {
            en: 'Selected number of people',
            hr: 'Trenutno odabran broj osoba',
        },
        min_people: {
            en: 'Minimum number of people',
            hr: 'Minimalan broj ljudi',
        },
        max_people: {
            en: 'Maximum number of people',
            hr: 'Maksimalan broj ljudi',
        },
        price: {
            en: 'Price',
            hr: 'Cijena usluga',
        },
        coupon_discount: {
            en: 'Coupon discount',
            hr: 'Kupon popust',
        },
        fee_description: {
            en: 'Only for online card payment. Covers the cost of transaction and platform maintenance.',
            hr: 'Samo za online plaćanje karticom. Pokriva trošak transakcije i održavanja platforme.',
        },
        total: {
            en: 'Total price',
            hr: 'Ukupna cijena',
        },
        next: {
            en: 'Next',
            hr: 'Sljedeći korak',
        },
        voucher: {
            en: 'Have a coupon code? Click here.',
            hr: 'Imate kod kupona? Kliknite tu.',
        },
    },
    stripe: {
        button: {
            pay_now: {
                en: 'PAY NOW',
                hr: 'PLATI SAD',
            },
        },
    },
    timepicker: {
        title: {
            en: 'Select your time',
            hr: 'Odaberite termin',
        },
        select_time: {
            en: 'Time',
            hr: 'Termin',
        },
        confirm: {
            en: 'Next',
            hr: 'Sljedeći korak',
        },
    },
    dateTimePreview: {
        edit: {
            en: 'Edit',
            hr: 'Izmjenite',
        },
        select_date: {
            en: 'Please select date',
            hr: 'Odaberite datum',
        },
        select_time: {
            en: 'Please select time',
            hr: 'Odaberite vrijeme',
        },
    },
    calendar: {
        title: {
            en: 'Select your date',
            hr: 'Odaberite datum',
        },
        confirm: {
            en: 'Next',
            hr: 'Sljedeći korak',
        },
        dayTranslations: {
            en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            hr: ['Ponedjeljak', 'Utorak', 'Srijeda', 'Četvrtak', 'Petak', 'Subota', 'Nedjelja'],
        },
        monthTranslations: {
            en: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],
            hr: [
                'Siječanj',
                'Veljača',
                'Ožujak',
                'Travanj',
                'Svibanj',
                'Lipanj',
                'Srpanj',
                'Kolovoz',
                'Rujan',
                'Listopad',
                'Studeni',
                'Prosinac',
            ],
        },
    },
    map: {
        services: {
            hr: 'Usluge',
            en: 'Services',
        },
        providers: {
            hr: 'Pružatelji usluge',
            en: 'Service providers',
        },
        choose_category: {
            hr: 'Kategorija',
            en: 'Category',
        },
        choose_destination: {
            hr: 'Destinacija',
            en: 'Destination',
        },
        no_services: {
            hr: 'Nema rezultata. Pokušajte ponovno.',
            en: 'No results. Try again.',
        },
        what_else: {
            hr: 'Što sve mogu pretraživati?',
            en: 'What else can I search?',
        },
        reset_filter: {
            hr: 'Resetiraj',
            en: 'Reset',
        },
        price_person: {
            hr: 'po osobi',
            en: 'per person',
        },
        price_group: {
            hr: 'grupa',
            en: 'per group',
        },
        price_group_amount: {
            hr: (people) => `(Maks. ${people} ljudi)`,
            en: (people) => `(Max ${people} people)`,
        },
        price_from: {
            hr: 'od',
            en: 'from',
        },
        map_view: {
            hr: 'Prikaži mapu',
            en: 'Map view',
        },
        list_view: {
            hr: 'Prikaz liste',
            en: 'List view',
        },
        filters: {
            button: {
                hr: 'Filteri',
                en: 'Filters',
            },
            title: {
                hr: 'Filteri',
                en: 'Filters',
            },
            num_people: {
                hr: 'Broj osoba',
                en: 'Number of people',
            },
            price: {
                hr: 'Cijena (po osobi)',
                en: 'Price (per person)',
            },
            in_advance: {
                hr: 'Uvjet ranije rezervacije (minimalno prije početka usluge)',
                en: 'Booking condition (minimum before the start of service)',
            },
            not_selected: {
                hr: 'Nije odabrano',
                en: 'Not selected',
            },
            tags: {
                hr: 'Oznake',
                en: 'Tags',
            },
            additional_characteristics: {
                hr: 'Dodatne mogućnosti',
                en: 'Additional features',
            },
            guided_tour: {
                hr: 'Vođena agencijska tura',
                en: 'Guided agency tour',
            },
            private_group: {
                hr: 'Privatno iskustvo',
                en: 'Private experience',
            },
            mixed_group: {
                hr: 'Miješana grupa',
                en: 'Mixed group',
            },
            select_yes: {
                hr: 'Da',
                en: 'Yes',
            },
            select_no: {
                hr: 'Ne',
                en: 'No',
            },
            apply_filters: {
                hr: 'Filtriraj',
                en: 'Apply filters',
            },
        },
        cta_title: {
            hr: 'Niste pronašli ono što tražite?',
            en: `Didn’t find what you are looking for?`,
        },
        cta_description: {
            hr: 'Kontaktirajte nas, a mi ćemo organizirati izlet samo za Vas.',
            en: `Get in touch with us and we'll arrange a tour just for you.`,
        },
        cta_btn_text: {
            hr: 'Kontaktirajte nas',
            en: 'Contact us',
        },
    },
    what_to_search: {
        title: {
            hr: 'Kako koristiti pretraživač?',
            en: 'How to use the search engine?',
        },
        examples_title: {
            hr: 'Primjeri',
            en: 'Examples',
        },
        examples_text: {
            hr:
                'Ovisno o tome što tražite, možete upisati nešto poput: Kajakarenje za 4 osobe, privatna tura, Tražite ‘iskustva ispod 100€’, Iznajmljivanje Jet ski-a za 2 osobe, Quad safari u blizini Zadra, Tura brodom za grupu od 8 osoba, Split...',
            en:
                'Depending on what you are looking for, you can type something like: Kayaking for 4 people, private tour, Search for ‘experiences under 100€’, Rent a Jet ski for 2 people, Quad safari near Zadar, Boat tour for group of 8 people, Split...',
        },
        categories_regions_title: {
            hr: 'Koristite kategorije i regije',
            en: 'Use categories and regions',
        },
        categories_regions_subtitle: {
            hr: 'Trenutno su naši oglasi grupirani prema kategorijama i destinacijama navedenim u nastavku:',
            en: 'Currently, our listings are grouped by categories and destinations listed below:',
        },
        categories_title: {
            hr: 'Kategorije',
            en: 'Categories',
        },
        destinations_title: {
            hr: 'Destinacije',
            en: 'Destinations',
        },
        beer_tasting: {
            hr: 'Degustacija piva',
            en: 'Beer tasting',
        },
        boat_rental: {
            hr: 'Iznajmljivanje brodova',
            en: 'Boat rental',
        },
        boat_tours: {
            hr: 'Ture brodom',
            en: 'Boat tours',
        },
        cooking_classes: {
            hr: 'Kulinarske klase',
            en: 'Cooking classes',
        },
        culture_trips: {
            hr: 'Kulturne ture',
            en: 'Culture trips & tours',
        },
        liqueur_tasting: {
            hr: 'Degustacija likera',
            en: 'Liqueur tasting',
        },
        local_gastro_experiences: {
            hr: 'Lokalne gastro iskustva',
            en: 'Local gastro experiences',
        },
        local_tours: {
            hr: 'Lokalne ture i izleti',
            en: 'Local tours & excursions',
        },
        olive_oil_tasting: {
            hr: 'Degustacija maslinovog ulja',
            en: 'Olive oil tasting',
        },
        outdoor_activities: {
            hr: 'Aktivnosti na otvorenom',
            en: 'Outdoor activities',
        },
        private_transfer: {
            hr: 'Privatni transfer',
            en: 'Private transfer',
        },
        wine_tasting: {
            hr: 'Degustacija vina i ture',
            en: 'Wine tasting & tours',
        },
        wine_tours: {
            hr: 'Ture vinom',
            en: 'Wine tours',
        },
        croatia: {
            hr: 'Hrvatska',
            en: 'Croatia',
        },
        istria: {
            hr: 'Istra',
            en: 'Istria',
        },
        krk: {
            hr: 'Otok Krk',
            en: 'Krk Island',
        },
        central_istria: {
            hr: 'Središnja Istra',
            en: 'Central Istria',
        },
        other_params_title: {
            hr: 'Ostali parametri',
            en: 'Other parameters',
        },
        other_params_paragraph: {
            hr:
                'Upišite broj osoba, cijenu, da li je za grupu ili pojedinca, bilo koju dodatnu funkciju kao što su besplatan transfer, besplatno parkiranje, wifi, klima uređaj itd.',
            en:
                'Type in the number of persons, group or single person, price, anything else that might interest you, such as a free transfer, free parking, wifi, air conditioning, and so on.',
        },
    },
    pagination: {
        'nav-label': {
            en: 'Pagination Navigation',
            hr: 'Paginacija',
        },
        previous: {
            en: 'Previous page',
            hr: 'Prethodna stranica',
        },
        next: {
            en: 'Next page',
            hr: 'Sljedeća stranica',
        },
        'go-to-page': {
            en: (p) => 'Go to page ' + p,
            hr: (p) => 'Idi na stranicu broj ' + p,
        },
        results: {
            en: (num) => (num === 1 ? '1 result' : `${num} results`),
            hr: (num) => (num === 1 ? '1 rezultat' : `${num} rezultata`),
        },
    },
    service: {
        price_from: {
            hr: 'od',
            en: 'from',
        },
        available: {
            hr: (available) => (available ? 'Dostupno' : 'Nedostupno'),
            en: (available) => (available ? 'Available' : 'Unavailable'),
        },
        price_person: {
            hr: 'po osobi',
            en: 'per person',
        },
        free_cancellation: {
            hr: 'Besplatno otkazivanje',
            en: 'Free cancellation',
        },
        price_group: {
            hr: (people) => `Grupa (Maks. ${people} ljudi)`,
            en: (people) => `per group (Max ${people} people)`,
        },
    },
};
